import { useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import LiveFeedBar from "@/pages/home/components/LiveFeedBar";
import ArchiveIndex from "@/pages/home/components/ArchiveIndex";
import TopicWall from "@/pages/home/components/TopicWall";
import Timeline from "@/pages/home/components/Timeline";
import EvidenceBoard from "@/pages/home/components/EvidenceBoard";
import StatsStrip from "@/pages/home/components/StatsStrip";
import DeepDive from "@/pages/home/components/DeepDive";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  const [activeTag, setActiveTag] = useState("");

  const handlePickTag = (tag: string) => {
    setActiveTag((current) => (current === tag ? "" : tag));
  };

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection onPickTag={handlePickTag} activeTag={activeTag} />
        <LiveFeedBar />
        <ArchiveIndex />
        <TopicWall />
        <Timeline />
        <EvidenceBoard />
        <StatsStrip />
        <DeepDive />
      </main>
      <SiteFooter />
    </div>
  );
}